(function () {
  if (window.StickyATC) return;

  var FORM_SCOPE = '#main-product-container #main-product .product-form';

  var root = document.getElementById('sticky-atc-root');
  var mainForm = document.querySelector(FORM_SCOPE);
  if (!root || !mainForm) return;

  var productIdField = document.getElementById('product-id');
  var qtyInput = mainForm.querySelector('input.quantity-selector, #quantity');
  var minusQty = mainForm.querySelector('.minus-qty');
  var plusQty = mainForm.querySelector('.plus-qty');
  var submitContainer = mainForm.querySelector('.submit-button-container');
  var sizeSelectorSection = mainForm.querySelector('#sizeLabelContainer') || mainForm.querySelector('.variant-sizes');
  var variantRadioWrapper = mainForm.querySelector('#variantRadioWrapper') || mainForm.querySelector('.variant-radio-wrapper');
  var titleWrapper = document.querySelector('#main-product-container #main-product .product-title-wrapper');
  var galleryWrapper = document.querySelector('.js-desktop-images-wrapper');

  var sizeWrapper = root.querySelector('.js-sticky-atc-size');
  var sizeTrigger = root.querySelector('.js-sticky-atc-size-trigger');
  var sizePanel = root.querySelector('.js-sticky-atc-size-panel');
  var sizeOptionsContainer = root.querySelector('.js-sticky-atc-size-options');
  var sizeLabelEls = root.querySelectorAll('.js-sticky-atc-size-label');
  var sizeLabelMobileEls = root.querySelectorAll('.js-sticky-atc-size-label-mobile');
  var priceValueEls = root.querySelectorAll('.js-sticky-atc-price-value');
  var priceCompareEls = root.querySelectorAll('.js-sticky-atc-price-compare');
  var qtyValueEl = root.querySelector('.js-sticky-atc-qty-value');
  var qtyMinusBtn = root.querySelector('.js-sticky-atc-qty-minus');
  var qtyPlusBtn = root.querySelector('.js-sticky-atc-qty-plus');
  var addButtons = root.querySelectorAll('.js-sticky-atc-button, .js-sticky-atc-button-mobile');
  var buttonLabels = root.querySelectorAll('.js-sticky-atc-button-label, .js-sticky-atc-button-label-mobile');
  var changeLink = root.querySelector('.js-sticky-atc-change');
  var sizeGuideBtn = root.querySelector('.js-sticky-atc-size-guide');
  var titleEls = root.querySelectorAll('.js-sticky-atc-title');
  var colourEls = root.querySelectorAll('.js-sticky-atc-colour');
  var imageEls = root.querySelectorAll('.js-sticky-atc-image');

  // Mirrors the size-conversion text baked into the SSR variant radios (sections/main-product-qf.liquid),
  // needed because a colour-swatch change rebuilds the size options entirely client-side (custom.js)
  // with no such text of its own to copy.
  var SIZE_CONVERSIONS = {
    XS: { label: 'Extra Small', GBP: '6-8', OTHER: '2-4' },
    S: { label: 'Small', GBP: '8-10', OTHER: '4-6' },
    M: { label: 'Medium', GBP: '10-12', OTHER: '6-8' },
    L: { label: 'Large', GBP: '12-14', OTHER: '8-10' },
    XL: { label: 'Extra Large', GBP: '14-16', OTHER: '10-12' },
    '1X': { label: 'Extra Large', GBP: '14-16', OTHER: '10-12' },
    '2X': { label: '2X Large', GBP: '16-18', OTHER: '12-14' },
    '3X': { label: '3X Large', GBP: '18-20', OTHER: '16-18' },
    '4X': { label: '4X Large', GBP: '20-22', OTHER: '18-20' }
  };

  var SIZE_OPTION_CHECK_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
    '<path d="M13.3326 4L5.99999 11.3328L2.66699 7.99971" stroke="#FEFFED" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>';

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getMoneyFormat() {
    return (window.theme && window.theme.moneyFormat) || (window.Shopify && Shopify.money_format) || '{{amount}}';
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat()).replace('.00', '');
    }
    var amount = (cents / 100).toFixed(2).replace('.00', '');
    var format = getMoneyFormat();
    var symbolMatch = format.match(/^[^{]*/);
    var symbol = symbolMatch ? symbolMatch[0] : '';
    return symbol ? symbol + amount : amount;
  }

  // The SSR-rendered variant radios carry data-price-numeric, but the radios custom.js
  // rebuilds after a colour-swatch change only carry data-price (a formatted string) —
  // so fall back to parsing that string whenever the numeric attribute is missing.
  function parsePriceNumeric(radio) {
    var numericAttr = radio.getAttribute('data-price-numeric');
    if (numericAttr) return parseFloat(numericAttr) || 0;
    var priceAttr = radio.getAttribute('data-price') || '';
    return parseFloat(priceAttr.replace(/[^0-9.]/g, '')) || 0;
  }

  function getSelectedRadio() {
    return mainForm.querySelector('.variant-radios:checked');
  }

  function closeSizePanel() {
    if (!sizeWrapper) return;
    sizeWrapper.classList.remove('is-open');
    if (sizeTrigger) sizeTrigger.setAttribute('aria-expanded', 'false');
  }

  function updateQtyDisplay() {
    if (qtyValueEl && qtyInput) qtyValueEl.textContent = qtyInput.value || '1';
  }

  function updateAvailability(radio) {
    var available = radio ? radio.getAttribute('data-stock') !== 'false' : true;
    addButtons.forEach(function (btn) {
      btn.disabled = !available;
      // A radio is only passed in once something has actually been selected, so
      // "needs selection" is resolved either way — revert to normal ATC behaviour.
      btn.classList.remove('is-needs-selection');
    });
    buttonLabels.forEach(function (label) {
      label.textContent = available ? 'Add to Basket' : 'Sold Out';
    });
  }

  function updatePrice() {
    var multiBuyPriceEl = mainForm.querySelector('.submit-button.button-2 .multi-buy-price');
    var multiBuyEl = document.querySelector('multi-buy');
    var multiBuyActive = multiBuyEl && !multiBuyEl.classList.contains('is-hidden');

    if (multiBuyActive && multiBuyPriceEl) {
      var text = multiBuyPriceEl.textContent.trim();
      priceValueEls.forEach(function (el) { el.textContent = text; });
      priceCompareEls.forEach(function (el) { el.style.display = 'none'; });
      return;
    }

    var radio = getSelectedRadio();
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (radio) {
      var cents = Math.round(parsePriceNumeric(radio) * qty * 100);
      priceValueEls.forEach(function (el) { el.textContent = formatMoney(cents); });
    } else if (multiBuyPriceEl) {
      var fallbackText = multiBuyPriceEl.textContent.trim();
      priceValueEls.forEach(function (el) { el.textContent = fallbackText; });
    }
    priceCompareEls.forEach(function (el) { el.style.display = 'none'; });
  }

  function bindSizeOptionClicks() {
    if (!sizeOptionsContainer) return;
    sizeOptionsContainer.querySelectorAll('.js-sticky-atc-size-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.disabled) return;
        var variantId = opt.getAttribute('data-variant-id');
        var radio = mainForm.querySelector('.variant-radios[value="' + variantId + '"]');
        if (!radio) return;
        radio.click();
      });
    });
  }

  // Rebuilds the sticky bar's size dropdown from whatever .variant-radios currently exist
  // in the main form, rather than trusting the initial SSR markup — a colour-swatch change
  // (custom.js) replaces #variantRadioWrapper's entire contents client-side with a different
  // product's variants (different ids, no page reload), so the option list must be re-derived.
  function rebuildSizeOptions() {
    if (!sizeOptionsContainer) return;
    var shopCurrency = variantRadioWrapper ? variantRadioWrapper.getAttribute('data-shop-currency') : '';
    var radios = mainForm.querySelectorAll('.variant-radios');
    var html = '';

    radios.forEach(function (radio) {
      var id = radio.value;
      var title = radio.getAttribute('data-title') || '';
      var available = radio.getAttribute('data-stock') !== 'false';
      var conversion = SIZE_CONVERSIONS[title];
      var descriptionText = conversion
        ? conversion.label + ' (' + (shopCurrency === 'GBP' ? 'UK ' + conversion.GBP : conversion.OTHER) + ')'
        : '';

      html += '<button type="button" class="sticky-atc__size-option js-sticky-atc-size-option' +
        (radio.checked ? ' is-selected' : '') + (available ? '' : ' is-disabled') + '"' +
        ' data-variant-id="' + escapeHtml(id) + '"' + (available ? '' : ' disabled') + '>' +
        '<span class="sticky-atc__size-option-text">' +
        '<span class="sticky-atc__size-option-code">' + escapeHtml(title) + '</span>' +
        (descriptionText ? '<span class="sticky-atc__size-option-desc">' + escapeHtml(descriptionText) + '</span>' : '') +
        '</span>' +
        '<span class="sticky-atc__size-option-check">' + (radio.checked ? SIZE_OPTION_CHECK_ICON : '') + '</span>' +
        '</button>';
    });

    sizeOptionsContainer.innerHTML = html;
    bindSizeOptionClicks();
  }

  function updateFromRadio(radio) {
    sizeOptionsContainer && sizeOptionsContainer.querySelectorAll('.js-sticky-atc-size-option').forEach(function (opt) {
      var isSelected = radio ? opt.getAttribute('data-variant-id') === radio.value : false;
      opt.classList.toggle('is-selected', isSelected);
      var check = opt.querySelector('.sticky-atc__size-option-check');
      if (check) check.innerHTML = isSelected ? SIZE_OPTION_CHECK_ICON : '';
    });
    if (!radio) return;
    var title = radio.getAttribute('data-title') || radio.value;
    sizeLabelEls.forEach(function (el) { el.textContent = title; });
    var shopCurrency = variantRadioWrapper ? variantRadioWrapper.getAttribute('data-shop-currency') : '';
    var conversion = SIZE_CONVERSIONS[title];
    var mobileLabel = conversion ? title + ' (' + (shopCurrency === 'GBP' ? conversion.GBP : conversion.OTHER) + ')' : title;
    sizeLabelMobileEls.forEach(function (el) { el.textContent = mobileLabel; });
    updateAvailability(radio);
    updatePrice();
    updateQtyDisplay();
    closeSizePanel();
  }

  // Mirrors title / colour / thumbnail after a colour-swatch change, since that swap
  // (custom.js) rewrites those elements directly via jQuery .html()/attr() with no
  // page reload and no event of its own to hook into.
  function syncProductChrome() {
    if (titleWrapper) {
      var h1 = titleWrapper.querySelector('h1');
      var subtitle = titleWrapper.querySelector('.subheading-lg');
      if (h1) {
        var titleText = h1.textContent.trim();
        titleEls.forEach(function (el) { el.textContent = titleText; });
      }
      if (subtitle) {
        var colourText = subtitle.textContent.trim();
        colourEls.forEach(function (el) { el.textContent = colourText; });
      }
    }
    if (galleryWrapper) {
      var img = galleryWrapper.querySelector('img.js-desktop-image-item:not(.is-hidden)');
      var src = img && img.getAttribute('src');
      if (src) {
        imageEls.forEach(function (el) { el.setAttribute('src', src); });
      }
    }
  }

  // ---------- Visibility (IntersectionObserver) ----------
  function isForceHidden() {
    return root.classList.contains('is-scroll-hidden') || root.classList.contains('is-drawer-open');
  }

  // The IntersectionObserver's callback is a no-op while isForceHidden() is true (e.g.
  // during the "Change" link's scroll), so its last real update from mid-scroll gets
  // dropped on the floor. Used to explicitly recheck reality once a forced-hide window
  // ends, instead of silently falling back to whatever stale .is-visible state predates it.
  function refreshVisibilityNow() {
    if (!submitContainer || isForceHidden()) return;
    var rect = submitContainer.getBoundingClientRect();
    var inView = rect.top < window.innerHeight && rect.bottom > 0;
    root.classList.toggle('is-visible', !inView);
    root.setAttribute('aria-hidden', inView ? 'true' : 'false');
  }

  if (submitContainer && 'IntersectionObserver' in window) {
    var visibilityRaf = null;

    var visibilityObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Coalesce rapid, sub-pixel-triggered callbacks (common right at the viewport edge
      // during scroll) into a single class change per frame, instead of restarting the
      // slide transition several times in quick succession.
      if (visibilityRaf) cancelAnimationFrame(visibilityRaf);
      visibilityRaf = requestAnimationFrame(function () {
        if (isForceHidden()) return;
        root.classList.toggle('is-visible', !entry.isIntersecting);
        root.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, {
      threshold: 0,
      // A small buffer so the bar only shows once the trigger has genuinely left the
      // viewport (and hides only once it's genuinely back), rather than flickering
      // exactly at the boundary.
      rootMargin: '0px 0px -24px 0px'
    });
    visibilityObserver.observe(submitContainer);
  }

  // ---------- Stay out of the way of the mobile nav drawer and cart drawer ----------
  // Neither drawer's open/close dispatches an event we could hook into for the nav
  // drawer (assets/mobile-menu.js just toggles a class), so its state is observed
  // directly; the cart/side-cart drawer does dispatch events, which is more reliable.
  // Both funnel into one function that re-checks both drawers' actual current state,
  // rather than each independently adding/removing the class (which could otherwise
  // have one drawer's close wipe out a class the other drawer still needs).
  var mobileMenuContainer = document.getElementById('mobile-menu-container');

  function updateDrawerHiddenState() {
    var navOpen = !!(mobileMenuContainer && mobileMenuContainer.classList.contains('active'));
    var cartDrawer = document.getElementById('cart-drawer-container');
    var cartOpen = !!(cartDrawer && cartDrawer.classList.contains('open'));
    root.classList.toggle('is-drawer-open', navOpen || cartOpen);
  }

  if (mobileMenuContainer && 'MutationObserver' in window) {
    new MutationObserver(updateDrawerHiddenState)
      .observe(mobileMenuContainer, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('side_cart_opened', updateDrawerHiddenState);
  window.addEventListener('side_cart_closed', updateDrawerHiddenState);

  // ---------- Variant sync (size radio changes on the main form) ----------
  mainForm.querySelectorAll('.variant-radios').forEach(function (radio) {
    radio.addEventListener('change', function (e) { updateFromRadio(e.target); });
  });

  // Re-derive the dropdown and re-bind whenever the main form's radios are replaced
  // wholesale (colour-swatch change) rather than just having one radio's state flip.
  if (variantRadioWrapper && 'MutationObserver' in window) {
    new MutationObserver(function () {
      rebuildSizeOptions();
      updateFromRadio(getSelectedRadio());
      mainForm.querySelectorAll('.variant-radios').forEach(function (radio) {
        radio.addEventListener('change', function (e) { updateFromRadio(e.target); });
      });
    }).observe(variantRadioWrapper, { childList: true });
  }

  if (titleWrapper && 'MutationObserver' in window) {
    new MutationObserver(syncProductChrome).observe(titleWrapper, { childList: true, subtree: true, characterData: true });
  }
  if (galleryWrapper && 'MutationObserver' in window) {
    new MutationObserver(syncProductChrome).observe(galleryWrapper, { attributes: true, attributeFilter: ['src'], subtree: true });
  }

  // ---------- Size dropdown open/close ----------
  if (sizeTrigger && sizeWrapper && sizePanel) {
    sizeTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = !sizeWrapper.classList.contains('is-open');
      sizeWrapper.classList.toggle('is-open', willOpen);
      sizeTrigger.setAttribute('aria-expanded', String(willOpen));
    });
    document.addEventListener('click', function (e) {
      if (!sizeWrapper.contains(e.target)) closeSizePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSizePanel();
    });
  }

  // ---------- Quantity stepper (proxies the main form's stepper) ----------
  if (qtyMinusBtn && minusQty) qtyMinusBtn.addEventListener('click', function () { minusQty.click(); });
  if (qtyPlusBtn && plusQty) qtyPlusBtn.addEventListener('click', function () { plusQty.click(); });

  window.addEventListener('quantity-selector-changed', function () {
    updateQtyDisplay();
    updatePrice();
  });

  // Steps the main form's own minus button back down to 1 (rather than writing the input
  // directly) so its button label, price and multi-buy progress all update the same way a
  // manual decrease would, with quantity-selector-changed then syncing this bar.
  function resetQuantity() {
    if (!qtyInput || !minusQty) return;
    var guard = parseInt(qtyInput.value, 10) || 1;
    while ((parseInt(qtyInput.value, 10) || 1) > 1 && guard-- > 0) {
      minusQty.click();
    }
    updateQtyDisplay();
  }

  // Only reset after an add from this PDP (sticky button or main form), not on every
  // cart_changed, since side-cart quantity edits fire that event too.
  var pendingPdpAdd = false;

  // The main form's submit is handled (and preventDefault-ed) by global_listeners.js,
  // but it still bubbles up to the .product-form wrapper.
  mainForm.addEventListener('submit', function () {
    pendingPdpAdd = true;
  });

  window.addEventListener('cart_changed', function () {
    if (pendingPdpAdd) {
      pendingPdpAdd = false;
      resetQuantity();
    }
    setTimeout(updatePrice, 50);
  });

  // ---------- Mobile "Change" link (and, when no size is picked yet, the mobile
  // Add to Basket button itself — see the "Add to Basket" section below) ----------
  function scrollToSizeSelector() {
    if (!sizeSelectorSection) return;
    root.classList.add('is-scroll-hidden');
    sizeSelectorSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      root.classList.remove('is-scroll-hidden');
      refreshVisibilityNow();
    }, 700);
  }

  if (changeLink) {
    changeLink.addEventListener('click', scrollToSizeSelector);
  }

  // ---------- Size Guide ----------
  // Proxies a click to the real Kiwi Sizing trigger on the main form so the same modal
  // opens in place — no navigation, no scroll. Kiwi (a Shopify app block, not theme code)
  // injects its trigger as a sibling inside #sizeLabelContainer / .variant-sizes using one
  // of two markup patterns confirmed via assets/style.css's own Kiwi-specific overrides:
  // ".sizing-chart-container > ._ks_text.ks-chart-modal-link" or
  // ".ks-calculator-container > span.ks-calculator-modal-link". Queried lazily (not cached
  // at init) since Kiwi injects asynchronously after this script runs.
  var KIWI_TRIGGER_SELECTOR = '.ks-chart-modal-link, .ks-calculator-modal-link, ._ks_text';

  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeSizePanel();
      var trigger = mainForm.querySelector(KIWI_TRIGGER_SELECTOR);
      if (trigger) {
        trigger.click();
        return;
      }
      var fallbackHref = sizeGuideBtn.getAttribute('data-fallback-href');
      if (fallbackHref) window.location.href = fallbackHref;
    });
  }

  // ---------- Add to Basket ----------
  addButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Mobile button stays natively enabled while a size still needs picking (a
      // disabled button can't be clicked at all) — tapping it scrolls up instead.
      if (btn.classList.contains('is-needs-selection')) {
        scrollToSizeSelector();
        return;
      }
      if (btn.disabled || !window.qf_cart || typeof window.qf_cart.addToCart !== 'function') return;
      var id = productIdField ? productIdField.value : null;
      var quantity = qtyInput ? qtyInput.value : 1;
      if (!id || !quantity) return;

      btn.classList.add('is-loading');
      setTimeout(function () { btn.classList.remove('is-loading'); }, 2000);

      pendingPdpAdd = true;
      window.qf_cart.addToCart(id, quantity);
    });
  });

  // ---------- Init ----------
  rebuildSizeOptions();
  updateFromRadio(getSelectedRadio());
  updateQtyDisplay();
  updatePrice();

  window.StickyATC = {
    refresh: function () {
      rebuildSizeOptions();
      updateFromRadio(getSelectedRadio());
      updateQtyDisplay();
      updatePrice();
      syncProductChrome();
    }
  };
})();
